import { HardHat, Microscope, Cog, Leaf, Target } from "lucide-react";

const ABOUT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/5d609f59-ef3b-4635-81e0-3a6a2e70cc39/images/dfbadfa579d55cd24597e7d31f60d9adce586a621ae4b7e8d393e8c59e5cb7dc.png";

const PILLAR_ICONS = [HardHat, Microscope, Cog, Leaf];

const About = ({ t }) => {
  return (
    <section id="about" data-testid="about-section" className="relative bg-white py-24 sm:py-32">
      <div className="bid-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Image column */}
          <div className="lg:col-span-5 relative">
            <div className="relative overflow-hidden border border-[#0a192f]/10">
              <img
                src={ABOUT_IMG}
                alt="Equipe técnica BID"
                className="w-full h-[420px] sm:h-[540px] object-cover"
                data-testid="about-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a192f]/40 to-transparent" />
            </div>
            {/* Floating mission card */}
            <div className="absolute -bottom-8 -right-2 sm:-right-8 max-w-xs bg-[#0a192f] text-white p-7 border border-[#d4af37]/30 shadow-xl">
              <div className="flex items-center gap-2 mb-3">
                <Target className="w-4 h-4 text-[#d4af37]" />
                <span className="bid-overline text-[#d4af37] text-[10px]">
                  {t.about.mission.title}
                </span>
              </div>
              <p className="text-sm leading-relaxed text-white/90">{t.about.mission.text}</p>
            </div>
          </div>

          {/* Text column */}
          <div className="lg:col-span-7">
            <p className="bid-overline text-[#d4af37] mb-4" data-testid="about-overline">
              {t.about.overline}
            </p>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-display font-black text-[#0a192f] tracking-tight leading-tight"
              data-testid="about-title"
            >
              {t.about.title}
            </h2>
            <p className="mt-6 text-base sm:text-lg text-[#0a192f]/80 leading-relaxed font-medium">
              {t.about.lead}
            </p>
            {t.about.paragraphs.map((p, i) => (
              <p key={i} className="mt-4 text-base text-[#4a5568] leading-relaxed">
                {p}
              </p>
            ))}

            {/* Pillars */}
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#0a192f]/10 border border-[#0a192f]/10">
              {t.about.pillars.map((p, i) => {
                const Icon = PILLAR_ICONS[i] || HardHat;
                return (
                  <div
                    key={i}
                    className="bg-white p-6 hover:bg-[#f8f9fa] transition-colors"
                    data-testid={`about-pillar-${i}`}
                  >
                    <Icon className="w-6 h-6 text-[#d4af37] mb-3" strokeWidth={1.5} />
                    <h4 className="font-display font-bold text-[#0a192f] text-base">
                      {p.title}
                    </h4>
                    <p className="text-sm text-[#4a5568] mt-1 leading-relaxed">{p.text}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
